import React, { useState, useEffect, forwardRef } from 'react';
import Fetch from '../../../../../util/core/Fetch';

const RadioGroup = forwardRef((props, ref) => {
  const [selectedValue, setSelectedValue] = useState('');
  const [options, setOptions] = useState(props.options ? props.options : []);

  useEffect(() => {
    const loadOptions = async () => {
      let option = options.filter(opt => opt.selected);

      if (props.value === "") {
        setSelectedValue(option[0].value);
      } else {
        setSelectedValue(props.value);
      }

      if (props.optionsEndpoint && props.optionsEndpoint.endpoint) {
        let url = props.optionsEndpoint.endpoint;
        let keyLabel = props.optionsEndpoint.label;
        let keyValue = props.optionsEndpoint.value;
        const params = props.optionsEndpoint.params ? props.optionsEndpoint.params : {};
        let rows = await Fetch.post(url, params);

        const tempOptions = rows.map(item => (
          {
            value: item[keyValue],
            label: item[keyLabel]
          }
        ));
        setOptions(tempOptions);
      }
    }
    loadOptions();
  }, []);

  const handleRadioChange = (element) => {
    setSelectedValue(element.target.value);
    props.onChange({
      name: props.name,
      type: 'select',
      ...element
    });
  };

  const disabledStyle = {
    pointerEvents: 'none',
    opacity: 0.7,
    filter: 'grayScale(1)'
  }

  return (
    <div ref={ref} style={props.disabled ? disabledStyle : {}}>
      {options &&
        options.map((option) => (
          <label className="mr-2" key={option.value}>
            <input
              type="radio"
              name={props.name}
              value={option.value}
              checked={selectedValue === option.value}
              onChange={handleRadioChange}
              className="mr-1"
            />
            {option.label}
          </label>
        ))}
      {props.error && (
        <span
          className="error invalid-feedback"
          style={{ display: 'inline' }}>
          {props.error}
        </span>
      )}
    </div>
  );
})

export default RadioGroup;
